module.exports = __webpack_public_path__ + "img/right.f9f038a9.png";